import { html, nothing } from 'lit';
import { ifDefined } from 'lit/directives/if-defined';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './pager.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Pager extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      ellipsis: { type: Object },
      pages: { type: Array },
      title: { type: String },
    };
  }

  constructor() {
    super();
    this.ellipsis = { previous: false, next: false };
  }

  render() {
    return html`
      <nav role="navigation" title="${this.title}">
        <ul class="pager">
          ${this.pages.map((link, index, array) => {
            const isButton = !!link.iconName.length;
            const isActive = !!link.active;
            return html`${this.ellipsis.previous && index === 1
                ? html`<li
                    class="pager__item pager__item--ellipsis"
                    role="presentation"
                  >
                    &hellip;
                  </li>`
                : nothing}
              <li
                class="${classMap({
                  pager__item: true,
                  [`pager__item--${index}`]: true,
                  [`pager__item--button`]: isButton,
                  [`pager__item--first`]: index === 0,
                  [`pager__item--last`]: index === array.length - 1,
                })}"
              >
                <hf-link-button
                  arialabel="${ifDefined(link.iconName)}"
                  title="${ifDefined(link.title)}"
                  href=${link.url}
                  target="_self"
                  ignoredefault=${ifDefined(link.iconName ? undefined : true)}
                  icon="${ifDefined(link.iconName)}"
                  iconDirection="${ifDefined(link.iconDirection)}"
                  linkClass="btn__link--pager-${isButton
                    ? 'button'
                    : 'number'}${isActive ? '--active' : ''}"
                >
                  ${link.text}
                </hf-link-button>
              </li>
              ${this.ellipsis.next && index === array.length - 2
                ? html`<li
                    class="pager__item pager__item--ellipsis"
                    role="presentation"
                  >
                    &hellip;
                  </li>`
                : nothing}
            `
              ;
          })}
        </ul>
      </nav>
    `;
  }
}

customElements.define('hf-pager', Pager);
